import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { DocumentThumbnail, DocumentViewer } from "@miplatform/components";
import { DOCUMENT_CATEGORIES, SUBMIT_STATUSES } from "@miplatform/constants";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const IncompleteReason = ({
  open = true,
  attemptModifiedOn,
  dataProcessedTime,
  activities,
  getAttemptActivities,
  attempt,
}) => {
  const { classes } = useStyles();
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const documents = attempt.documents
    ? attempt.documents.filter(
        (item) => item.category === DOCUMENT_CATEGORIES.CANNOT_PERFORM_IMAGE
      )
    : [];

  useEffect(() => {
    if (open && (!activities || activities.length === 0)) {
      getAttemptActivities();
    }
  }, [open, dataProcessedTime, attemptModifiedOn, getAttemptActivities]);
  const unableToStartActivity = activities?.find(
    (activity) => activity.activityType === SUBMIT_STATUSES.UNABLE_TO_START
  );

  if (activities?.length === 0) return null;

  return (
    <Box className={classes.root}>
      <Box className={classes.noteContainer}>
        <Typography className={classes.title}>
          Attempt submitted cannot be performed
        </Typography>
        <Box className={classes.note}>
          <Typography className={classes.label}>Reason:</Typography>
          <Typography className={classes.value}>
            {unableToStartActivity?.reason}
          </Typography>
        </Box>
        <Box className={classes.note}>
          <Typography className={classes.label}>Note:</Typography>
          <Typography className={classes.value}>
            {unableToStartActivity?.notes}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.documents}>
        <DocumentThumbnail
          document={documents[0]}
          documentCount={documents.length}
          dimension={60}
          onClick={
            documents.length ? () => setShowDocumentViewer(true) : undefined
          }
          style={{}}
        />
      </Box>
      <DocumentViewer
        documents={documents}
        fullScreenStatus={showDocumentViewer}
        onUnfullscreen={() => setShowDocumentViewer(false)}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    border: `1px solid ${theme.palette.red.accent}`,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.red.light,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  noteContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    alignItems: "flex-start",
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.red.dark,
  },
  note: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(0.5),
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.grey.dark,
  },
  value: {
    fontSize: 12,
    color: theme.palette.grey.dark,
  },

  document: {
    marginTop: theme.spacing(2),
  },
}));

export default IncompleteReason;
